import { WifiOff } from "lucide-react";
import type { UploaderStatus } from "@/recorder/uploader";

export default function ConnectionChip({ status }: { status: UploaderStatus }) {
  if (status === "online" || status === "finalizing" || status === "finalized") {
    return (
      <span className="font-mono text-[10px] text-[#22C55E]">connected</span>
    );
  }
  if (status === "connecting") {
    return <span className="font-mono text-[10px] text-neutral-500">connecting…</span>;
  }
  return (
    <span className="flex items-center gap-1 font-mono text-[10px] text-[#F59E0B]">
      <WifiOff className="h-3 w-3" />
      offline - buffering locally
    </span>
  );
}
